import { RootState, useAppDispatch } from 'lib/centralStore';
import React, { ReactNode } from 'react';

import { CashoutDialog } from 'components/cashoutDialog';
import { setTicketCashout } from 'features/dashboard/myBets/myBetSlice';
import { useGetLabelsByKeys } from 'hooks/useLingUI';
import { useSelector } from 'react-redux';
import styles from './LayoutPersonalArea.module.scss';

export type LayoutPersonalAreaProps = {
  children: ReactNode;
  layoutMessage?: boolean;
  disableSidebar?: boolean;
};

/* eslint-disable no-unused-vars */
declare global {
  interface Window {
    engagentFormErrorCode: any;
    engagentFormErrorMsg: any;
  }
}
/* eslint-enable no-unused-vars */

export const LayoutPersonalArea = ({ children, layoutMessage, disableSidebar }: LayoutPersonalAreaProps) => {
  const dispatch = useAppDispatch();
  const { ticketCashout } = useSelector((store: RootState) => store.myBets);
  const [titleCashout, subtitleCashout, errorTitleCashout] = useGetLabelsByKeys([
    'cashout-dialog-title',
    'cashout-dialog-subtitle',
    'cashout-dialog-error-title',
  ]);

  return (
    <React.Fragment>
      <div
        className={
          !layoutMessage ? (disableSidebar ? styles.containerNoSidebar : styles.container) : styles.containerMessages
        }
      >
        {children}
      </div>
      {ticketCashout?.idBiglietto && (
        <CashoutDialog
          open={ticketCashout.idBiglietto !== undefined}
          onOpenChange={() => dispatch(setTicketCashout({ idBiglietto: undefined, importo: undefined }))}
          idBiglietto={ticketCashout.idBiglietto}
          title={titleCashout}
          titleError={errorTitleCashout}
          text={subtitleCashout}
        />
      )}
      {/* <SnaiPlusFrame /> */}
    </React.Fragment>
  );
};
